<template>
    <div>
        <Header></Header>
        <div class="items">
            <div class="top-message">
                <h1>出品した商品</h1>
            </div>
            <div class="sellingList">
                <div class="tab-buttons">
                    <span class="span1" @click="isSelect('content1')"  v-bind:class="{'active': isActive === 'content1'}" >出品中の商品</span>
                    <span class="span2" @click="isSelect('content2')"  v-bind:class="{'active': isActive === 'content2'}">購入された商品</span>
                    <!-- <div id="lamp" class="content1"></div> -->
                </div>
                <div class="tab-content">
                    <div class="content1" v-if="isActive === 'content1'">
                        <ul>
                            <li v-for="item in myItems" :key="item.itemID">
                                <router-link :to="{name: 'itemDetail', params:{id: item.itemID}}" >
                                    <article>
                                        <figure>
                                            <img :src="item.img_url" @click="selected(item)">
                                        </figure>
                                        <div class="text-content">
                                            <p>{{item.item}}</p>
                                            <button class="goTrade" @click="selected(item)">商品ページへ</button>
                                        </div>
                                    </article>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="content2" v-else-if="isActive === 'content2'">
                        <ul>
                            <li v-for="item in myItemsSoldOut" :key="item.itemID">
                                <router-link :to="{name: 'itemDetail', params:{id: item.itemID}}" >
                                    <article>
                                        <figure>
                                            <img :src="item.img_url" @click="selected(item)">
                                        </figure>
                                        <div class="text-content">
                                            <p>{{item.item}}</p>
                                            <button class="goTrade" @click="selected(item)">商品ページへ</button>
                                        </div>
                                    </article>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../components/Header.vue'
import firebase from 'firebase'
import db from '../plugins/firestore'

export default {
    components: {Header},
    data(){
        return {
            myItems:[],
            myItemsSoldOut:[],
            userName:'',
            isActive: 'content1' //表示中のタブ
        }
    },
    created(){
        firebase.auth().onAuthStateChanged(user => {
            if(!user){
                this.$router.push({path: "/"})
            }else{
                this.userName = user.displayName
                //出品中の教科書をfirestoreから取得して、myItems(出品中)に格納
                db.collection("textbooks").orderBy("timestamp", "desc").where("userID", "==", user.uid).where("isSold", "==", true).get().then(snap => {
                const array = [];
                snap.forEach(doc => {
                    const itemData = doc.data(); //itemDataオブジェクト（商品情報）を設定
                    itemData.itemID = doc.id; //itemDataにドキュメントIDを付与
                    array.push(itemData); //itemDataを配列arrayに入れる
                });
                this.myItems = array
                });

                //出品中の教科書をfirestoreから取得して、myItemsに格納
                db.collection("textbooks").orderBy("timestamp", "desc").where("userID", "==", user.uid).where("isSold", "==", false).get().then(snap => {
                const arraySoldOut = [];
                snap.forEach(doc => {
                    const itemData = doc.data(); //itemDataオブジェクト（商品情報）を設定
                    itemData.itemID = doc.id; //itemDataにドキュメントIDを付与
                    arraySoldOut.push(itemData); //itemDataを配列arrayに入れる
                });
                this.myItemsSoldOut = arraySoldOut
                });
            }
        })
    },
    methods: {
        //商品画像がクリックされたら、vuexにその商品のIDを格納して、ItemDetail.vueからアクセスできるようにする。
        selected(item){
            this.$store.dispatch('selected', item)
        },
        isSelect: function(content) {
            this.isActive = content;
        }
    }
}
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,300);
.sellingList{
    margin: 0 auto;
    width: 35%;
}

.tabs{
  /* width:50%; */
  margin:10px auto;
  position:relative;
}

.content1.active{
    color: red;
} 

/* .tab-buttons span{
  font:400 14px 'open sans',sans-serif;
  color:#333;
  background:#eee;
  cursor:pointer;
  border-bottom:2px solid #ddd;
  display:block;
  width:50%;
  float:left;
  text-align:center;
  height:40px;
  line-height:40px;
} */
.span1{
font:400 14px 'open sans',sans-serif;
  color:#333;
  /* background:#eee; */
  background-color: rgb(255, 255, 255);
  cursor:pointer;
  border-bottom:2px solid #ddd;
  display:block;
  width:50%;
  float:left;
  text-align:center;
  height:40px;
  line-height:40px;
}

.span1.active{
  background-color: rgba(20, 20, 20, 0.1);
}

.span2{
  font:400 14px 'open sans',sans-serif;
  color:#333;
  /* background:#eee; */
  background-color: rgb(255, 255, 255);
  cursor:pointer;
  border-bottom:2px solid #ddd;
  display:block;
  width:50%;
  float:left;
  text-align:center;
  height:40px;
  line-height:40px;
}

.span2.active{
  background-color: rgba(20, 20, 20, 0.1);

}

.tab-content{
    width: 100%;
    border-bottom:3px solid #ddd;
    padding:15px;
    /* background:#eee; */
    display:inline-block;
    font:400 13px 'open sans',sans-serif;
    color:#333;
}
/* 
#lamp{
  width: 33.3%;
  height:2px;
  background:#333;
  display:block;
  position:absolute;
  top:40px;
}

#lamp.content2{
  left:33.3%;
}

#lamp.content1{
  left:33.3%;
} */

article {
	display: flex;
	margin-bottom: 5px;
	padding: 15px;
	border-radius: 5px;
	box-sizing: border-box;
	box-shadow: 0 0 5px #999;
}

article figure {
	margin-right: 20px;
	width: 70px;
	height: 70px;
}

article figure img {
    width: 70px;
    height: 70px;
    vertical-align: top;
    object-fit: cover;
}

button {
    float: left;
}

.goTrade {
    border-radius: 4px;
    color: white;
    margin-top: 5px;
    padding: 4px 20px;
    background-color: rgb(53, 174, 243);
    opacity: 0.8;
}

ul {
    list-style: none;
}

li {
    margin: 10px;
}

@media all and (max-width:670px){
    .sellingList{
        width: 90%;
    }

    img {
        width: 90px;
        height: 90px;
    }
}


</style>